// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "HeroSection-module--wrapper--NvANj";
export var title = "HeroSection-module--title--M3VT+";
export var subtitle = "HeroSection-module--subtitle--hUpGW";
export var sectors = "HeroSection-module--sectors--3yKw4";